import React, { useState } from 'react'
import * as styles from './productSelect.module.css'
import ProductCard from './productCard'
import { graphql, useStaticQuery } from 'gatsby'

const ProductSelect = () => {
  // const products = [
  //   {
  //     name: 'landing',
  //     image: '../../images/landing.jpg',
  //     title: 'Landing Pages',
  //     desc: 'One-page sites created according to all the rules of effective landing pages.',
  //   },
  //   {
  //     name: 'multi-page',
  //     image:
  //       'https://stomshop.pro/image/cache/catalog/articles/blog-276/formlabs-form-3b-1-330x220.jpg',
  //     title: 'Multi Page Website',
  //     desc: 'Order a large, stylish website that will introduce your audience to your services and products.',
  //   },
  //   {
  //     name: 'store',
  //     image:
  //       'https://www.wpeform.io/static/1835705328e2a3287bbe156524bc1e6f/64606/seo-gatsbyjs.jpg',
  //     title: 'Online Store  Website',
  //     desc: 'Accept orders and payments through a stylish and functional online store.',
  //   },
  // ]

  const data = useStaticQuery(graphql`
    query {
      allContentfulIndexProduct {
        nodes {
          name
          productDescription
          productTitle
          productFeatures
          productImage {
            gatsbyImageData
          }
          buttonName
        }
      }
    }
  `)

  const products = data.allContentfulIndexProduct.nodes

  const [product, setProduct] = useState(products[0])
  const productHandler = (event) => {
    const productToRender = products.find(
      (el) => el.name === event.target.dataset.product
    )
    setProduct(productToRender)
  }
  return (
    <div className={styles.select}>
      <div className={styles.btnsGroup}>
        {products.map((el) => {
          return (
            <button
              key={el.name}
              data-product={el.name}
              onClick={productHandler}
              className={`${
                product.name === el.name ? `${styles.active}` : ''
              } ${styles.selectBtn}`}
            >
              {el.buttonName}
            </button>
          )
        })}
      </div>
      <ProductCard product={product} />
    </div>
  )
}

export default ProductSelect
